<div class="mdc-layout-grid newsfeed-result-list">
  <div class="mdc-layout-grid__inner">
    @for (item of results; track identifyNewsfeedResult($index, item)) {
    <div
      class="mdc-layout-grid__cell mdc-layout-grid__cell--span-4-desktop mdc-layout-grid__cell--span-4-tablet mdc-layout-grid__cell--span-2-phone">
      <bau365-result-teaser
        [markAsNew]="item.last_visited_at && item.published_at && item.last_visited_at < item.published_at"
        [item]="item"
        [pageContext]="'newsfeed'"
        [insightsId]="insightsId"
        [size]="size">
      </bau365-result-teaser>
    </div>
    }
  </div>
</div>
